<template>
  <div id="label" class="card">
    <div class="vx-row">
      <div class="vx-col lg:w-1/4 col-print-4">
        <img src="../../../assets/images/custom/bw-logo.png" class="logo" />
        <h4 class="text-center">avajang.com</h4>
      </div>
      <div class="vx-col lg:w-3/4 col-print-8">
        <div class="cardbox">
          <div class="header">
            <h2>{{ $t("Seller") }}</h2>
          </div>

          <h3 class="text-center" v-if="labelInfo.contractId">
            {{ $t("Avajang_Internet") }}
          </h3>
          <h4 :style="[labelInfo.contractId ? '' : { margin: '10px 0' }]">
            {{ $t("PhoneNumber") }}: ۸۴۵۰-۰۲۱ | {{ $t("PostalCode") }}:
            ۱۵۱۶۷۴۳۴۰۵
          </h4>
        </div>
      </div>
    </div>
    <div class="vx-row mx-0">
      <div class="vx-col col-print-8" style="width: 65%">
        <div class="vx-row">
          <div class="vx-col lg:w-1/2 col-print-6 px-1">
            <div class="cardbox">
              <div class="header">
                <h2>{{ $t("Transferee") }}</h2>
              </div>
              <div class="heightmatch1">
                <h4>{{ labelInfo.name }}</h4>
                <h4>{{ labelInfo.phoneNumber }}</h4>
              </div>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 col-print-6 px-1">
            <div class="cardbox">
              <div class="header">
                <h2>{{ $t("DateTimeSending") }}</h2>
              </div>
              <div class="heightmatch1">
                <h4 class="ltr">{{ currentTime }}</h4>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div
            :class="[
              labelInfo.contractId ? 'lg:w-1/2' : 'w-full',
              'vx-col col-print-6 px-1',
            ]"
          >
            <div class="cardbox">
              <div class="header">
                <h2>{{ $t("ShippingNumber") }}</h2>
              </div>
              <h4 class="heightmatch2">{{ labelInfo.shippingNumber }}</h4>
            </div>
          </div>
          <div
            class="vx-col lg:w-1/2 col-print-6 px-1"
            v-if="labelInfo.contractId"
          >
            <div class="cardbox">
              <div class="header">
                <h2>{{ $t("PaymentMethod") }}</h2>
              </div>
              <h4 class="heightmatch2" v-if="labelInfo.paymentType == 1">
                {{ $t("CreditPayment") }}
              </h4>
              <h4 class="heightmatch2" v-if="labelInfo.paymentType == 2">
                {{ $t("OnlinePayment") }}
              </h4>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full col-print-12 px-1">
            <div class="cardbox">
              <div class="header">
                <h2>{{ $t("ReceiverAddress") }}</h2>
              </div>
              <h4 class="reciever-info">
                {{ labelInfo.provinceName }}- {{ labelInfo.cityName }}-
                {{ labelInfo.address }}
                <br />
                {{ $t("PostalCode") }}: {{ labelInfo.postalCode }}
              </h4>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-col col-print-4 no-padding-r p-0" style="width: 35%">
        <div class="bordered" style="width: 100%">
          <QRCanvas :options="options" style="width: 70% !important" />
          <div class="order-number">{{ siteOrderNumber }}</div>
        </div>
        <div class="bordered bordered-box"></div>
      </div>
    </div>
    <div class="vx-row">
      <div class="w-full vx-col">
        <vs-button
          type="button"
          class="float-right purple hide-in-print"
          @click="printWindow()"
          >{{ $t("Print") }}</vs-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import * as moment from "jalali-moment";
import { QRCanvas } from "qrcanvas-vue";
import { URLS_CONSTANTS } from "../../../../config.js";
import "@/assets/scss/vuesax-rtl/_label.scss";

export default {
  name: "warehouseManagement_DischargePermission_Index",
  data() {
    return {
      siteOrderNumber: "",
      labelInfo: [],
      currentTime: "",
      options: {
        cellSize: 8,
        correctLevel: "H",
        data: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      recipientInfoDetails: "draftOrder/recipientInfoDetails",
    }),
  },
  mounted() {
    this.load();
    this.calcCurrentTime();
  },
  methods: {
    ...mapActions({
      fetchLabel: "draftOrder/fetchRecipientInfo",
    }),
    load() {
      var id = this.$route.params.id;
      this.fetchLabel(id).then(() => {
        this.labelInfo = Object.assign({}, this.recipientInfoDetails);
        var basketId = this.labelInfo.basketId;
        const image = new Image();

        image.src =
          URLS_CONSTANTS.post_logout_redirect_uri + "images/barcodeLogoBW.png";
        image.onload = () => {
          this.options = Object.assign({}, this.options, {
            logo: {
              image,
            },
          });
        };
        this.options.data =
          URLS_CONSTANTS.post_logout_redirect_uri +
          "ShowPackageInfo/" +
          basketId;
        // var contractIdFormat;
        // if (this.labelInfo.contractId) {
        //   contractIdFormat = ("000" + this.labelInfo.contractId).substr(-3);
        // } else {
        //   contractIdFormat = "000";
        // }
        // var invoiceIdFormat = ("0000" + this.labelInfo.basketId).substr(-4);
        // this.siteOrderNumber = "APO-" + contractIdFormat + invoiceIdFormat;
        this.siteOrderNumber = "APO-" + this.labelInfo.basketId;
      });
      setTimeout(() => {
        this.loaded = true;
      }, 500);
    },
    calcCurrentTime() {
      let todayJalali = moment().locale("fa").format("YYYY-M-D hh:mm:ss");
      this.currentTime = todayJalali;
    },
    printWindow() {
      window.print();
    },
  },
  components: {
    QRCanvas,
  },
};
</script>
